module.exports = __webpack_public_path__ + "assets/img/topImg.3b3becdb.png";